import { UploadApi } from 'woofwoof-api-public';
import client, { publicAxiosBaseUrl } from './client';

export const publicUploadApi = new UploadApi(
  {
    basePath: publicAxiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
